import { Combobox, Grid, Spinner } from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { getDisplayAdTemplates } from "api/services/displayAdsService";
import { Controller, useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useDisabledFields } from "../../useDisabledFields";
import { useDeltaTemplateContext } from "../util/CampaignTemplateContext";
import { useTranslation } from "react-i18next";
import { formMaxWidth } from "../../bundle";

export const DisplayAdSelection = () => {
  const { t } = useTranslation();

  const disabledFields = useDisabledFields();
  const { data } = useQuery(["all-display-ads"], getDisplayAdTemplates);
  const { watch } = useFormContext<ProgramService.ProgramModel>();

  const { campaignKey } = useDeltaTemplateContext();

  const id = watch(`${campaignKey}.externalDeltaTemplateId`);

  if (!data) {
    return <Spinner />;
  }

  return (
    <Grid
      columns={["1fr", "1fr 1fr"]}
      gap="l"
      style={{ maxWidth: formMaxWidth }}
    >
      <Controller
        name={`${campaignKey}.externalDeltaTemplateId`}
        render={({ field }) => (
          <Combobox
            items={data}
            valueObjectIndexAccessor="name"
            defaultItem={data.find(x => x.id === id)}
            onChange={item => {
              field.onChange(item.id);
            }}
            classNamePrefix={`${campaignKey}.externalDeltaTemplateId`}
            label={t(
              "programBuilder.program.template.delta.details.campaign.label"
            )}
            disabled={disabledFields(
              "bundleGroups.bundles.campaignTemplates.deltaTemplateId"
            )}
          />
        )}
      />
    </Grid>
  );
};
